import React from "react";

const TICKER_REPEAT_PER_BLOCK = 50;
const TICKER_BLOCK_COUNT = 2;

/**
 * Bottom ticker: continuous right-to-left scroll with seamless loop.
 * Text z dát sa zobrazí 100× (2 bloky × 50). Animácia posunie celý track o 100 %,
 * potom slučka skočí späť – oba bloky sú rovnaké, takže skok nie je viditeľný.
 */
function Ticker({ text }) {
  const trimmed = typeof text === "string" ? text.trim() : "";
  if (!trimmed) return null;

  const segment = `${trimmed}   •   `;
  const oneBlock = Array.from({ length: TICKER_REPEAT_PER_BLOCK }, (_, i) => (
    <span key={i} className="daily-menu-screen__ticker-segment">
      {segment}
    </span>
  ));

  const blocks = Array.from({ length: TICKER_BLOCK_COUNT }, (_, blockIndex) => (
    <span key={blockIndex} className="daily-menu-screen__ticker-block">
      {oneBlock}
    </span>
  ));

  return (
    <div className="daily-menu-screen__ticker-track-wrap">
      <div className="daily-menu-screen__ticker-track">{blocks}</div>
    </div>
  );
}

export default Ticker;
